'use client';

import { useAccountBalance } from '@/hooks/query/use-account-balance';
import { useAuthToken } from '@/store/auth';
import { useBetslipStore } from '@/store/betslip';
import { useEffect } from 'react';
import { Betslip as BetslipBase } from './betslip/betslip';
import { ConfirmBet } from './confirm-bet/confirm-bet';
import { useAccountInfo } from '@/hooks/query/account';
import { BetslipContextProvider } from './contexts/betslip-context';
import { AccountActStatus } from '@nf/utils-common/constants';
import { useSiteStore } from '@/store/site';
import { useCurrentProperties } from '@/hooks/query';
import { isNumberGames, isVirtualSports } from '@/services/settings.service';
import { useSelectedLayoutSegments } from 'next/navigation';
import { useAsideBetslip } from './hook/use-aside-betslip';
import { ReactPortal } from '@/components/widgets/react-portal';

const ConfirmBetBase = ({ renderStatus }:  {renderStatus:'float' | 'aside'}) => {
	return (
		<>
			{renderStatus === 'aside' ? (
				<ReactPortal wrapperId="modal-portal">
					<ConfirmBet />
				</ReactPortal>
			): (
				<ConfirmBet />
			)}
		</>
	)
}


// 有使用此component的地方
// 1. 在aside bar
// 2. layout元件, fixed在底部的形式
// 注意!! 兩個betslip元件中的provider獨立
export const Betslip = ({
	renderStatus  // 確保在畫面中的betslip只會有一個
}: {
	renderStatus: 'float' | 'aside'
}) => {
	const [
		isConfirmBet,
		isQuickBet,
		quickBetTicket,
		setIsParlayMode,
		currentMultiTickets
	] = useBetslipStore(state => [
		state.isConfirmBet,
		state.isQuickBet,
		state.quickBetTicket,
		state.setIsParlayMode,
		state.currentMultiTickets
	]);
	const { activeAsideBetSlip } = useAsideBetslip();
	
	const selectedLayoutSegments = useSelectedLayoutSegments();
	const isNoneSidePage = selectedLayoutSegments.includes('jackpot') || selectedLayoutSegments.includes('widget') || selectedLayoutSegments.includes('intro') || selectedLayoutSegments.includes('golden-duel');
	const authToken = useAuthToken();
	const { refetch } = useAccountBalance();
	const { user } = useAccountInfo();
	const { sport } = useCurrentProperties();
	const isThirdParty = isVirtualSports(sport) || isNumberGames(sport);
	const isParlayMode = useSiteStore(state => state.isParlayMode);
	
	useEffect(() => {
		if (isConfirmBet || (isQuickBet && !quickBetTicket)) {
			refetch();
		}
	}, [isConfirmBet, isQuickBet, quickBetTicket]);

	useEffect(() => {
		setIsParlayMode(isParlayMode);
	}, [isParlayMode]);

	const statusMap = {
		'float': !activeAsideBetSlip,
		'aside': activeAsideBetSlip,
	}

	if (isNoneSidePage) {
		return null;
	}

	return (
		<>
			{
				statusMap[renderStatus] && authToken && user && user.ActStatus == AccountActStatus.Deposited && !isThirdParty ? (
					<BetslipContextProvider
						acceptBetterOdds={user.BetterOdds}
						oddsType={user.OType}
						cashOutSportList={user.CashOutSportList ?? []}
						defaultStakeId={user.BetStake}
						quickBetStake={user.SportsQuickBetStake}
						quickStake={user.QBS}
						balance={user.BCredit}
						currencyName={user.LicenseeSiteSetting.DisplayCurrencyName}
						currencySymbol={user.LicenseeSiteSetting.DisplayCurrencySymbol}
						enableRewardSystem={user.RewardInfo.EnableRewardSystem}
						inpbetStake={user.InpbetStake}
						isIndependentMode={user.BettingMode === 1}
					>
						{
							isConfirmBet
								? <ConfirmBetBase renderStatus={renderStatus} />
								: (!isParlayMode || currentMultiTickets.length > 0) || renderStatus==='aside'
									? <BetslipBase />
									: null
						}
					</BetslipContextProvider>
				) : null
			}
		</>
	);
};